import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox,
  FDDeleteButton, FDPrimaryActionButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import metaOverrideSet from '../../metaOverrideSet';

const MatchLayout = ({
  onDelete,
}) => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction="row" spacing={2} justifyContent={'center'} alignItems={'center'}>
      <MetaControlField attr={'employerMatchLevelPercentage'} />
      <MetaControlField attr={'employerMatchPercentage'} />
      <FDDeleteButton
        onClick={onDelete ? () => onDelete(resource) : undefined}
        size={'sm'}
      />
    </FDStack>
  );
};

MatchLayout.propTypes = {
  onDelete: PropTypes.func.isRequired,
};


const EmployerMatchLayout = () => {
  const { resource, handleChange } = useMetaLayoutContext();

  const onAdd = () => {
    handleChange('electiveEmployerMatchingRules', resource.attr('electiveEmployerMatchingRules').create({
      addToCollection: true,
    }));
  };

  const onRemove = (i) => {
    resource.attr('electiveEmployerMatchingRules').resources().removeItemByIndex(i);
    handleChange('electiveEmployerMatchingRules', resource.attr('electiveEmployerMatchingRules'));
  };

  return (
    <FDStack direction={'column'} spacing={2}>
      <FDTitleText value="Elective Match Rules" />
      <FDStack direction="column" spacing={1}>
        {resource.attr('electiveEmployerMatchingRules').resources().list().map((entry, i) => {
          return (
            <FDBox margin={1}>
              <MetaResourceRenderer
                resource={entry}
                layout={MatchLayout}
                metaOverrideSet={metaOverrideSet}
                LayoutProps={{ onDelete: () => onRemove(i) }}
              />
            </FDBox>
          );
        })}
      </FDStack>
      <FDBox width={'50%'}>
        <FDPrimaryActionButton
          icon="add"
          iconPosition="start"
          label="Add Match Rule"
          onClick={() => onAdd(resource)}
          size="sm"
          isFullWidth={false}
        />
      </FDBox>
    </FDStack>
  );
};

EmployerMatchLayout.propTypes = {
};

export default EmployerMatchLayout;
